import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: () =>
      import(/* webpackChunkName: "New" */ "../components/Search.vue"),
    children: [
      {
        path: "/search",
        name: "search",
      },
    ],
    meta: {
      title: "Solarfox® Subscription",
    },
  },
  {
    path: "/checkout",
    name: "checkout",
    component: () =>
      import(/* webpackChunkName: "New" */ "../views/Checkout.vue"),
    meta: {
      title: "Solarfox® Checkout",
    },
  },
  {
    path: "/order",
    name: "order",
    component: () => import(/* webpackChunkName: "New" */ "../views/Order.vue"),
    meta: {
      title: "Solarfox® Order",
    },
  },
  {
    path: "/subscription",
    name: "subscription",
    component: () =>
      import(/* webpackChunkName: "New" */ "../views/Subscription.vue"),
    meta: {
      title: "Solarfox® Subscription",
    },
    children: [
      {
        path: "/subscription/info",
        name: "subscription/info",
        component: () =>
          import(
            /* webpackChunkName: "New" */ "../components/Subscription/Info.vue"
          ),
        meta: {
          title: "Solarfox® Subscription",
        },
      },
      {
        path: "/subscription/customer",
        name: "subscription/customer",
        component: () =>
          import(
            /* webpackChunkName: "New" */ "../components/Subscription/Customer.vue"
          ),
        meta: {
          title: "Solarfox® Subscription",
        },
      },
      {
        path: "/subscription/payment",
        name: "subscription/payment",
        component: () =>
          import(
            /* webpackChunkName: "New" */ "../components/Subscription/Payment.vue"
          ),
        meta: {
          title: "Solarfox® Subscription",
        },
      },
      {
        path: "/subscription/history",
        name: "subscription/history",
        component: () =>
          import(
            /* webpackChunkName: "New" */ "../components/Subscription/History.vue"
          ),
        meta: {
          title: "Solarfox® Subscription",
        },
      },
      {
        path: "/subscription/all",
        name: "subscription/all",
        component: () =>
          import(
            /* webpackChunkName: "New" */ "../components/Subscription/AllSubscriptions.vue"
          ),
        meta: {
          title: "Solarfox® Subscription",
        },
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

function hasQueryParams(route) {
  return !!Object.keys(route.query).length;
}

router.beforeEach((to, from, next) => {
  document.title = to.meta.title;
  if (!hasQueryParams(to) && hasQueryParams(from)) {
    next({ name: to.name, query: from.query });
  } else {
    next();
  }
});

export default router;
